import { type MCPServerInfo } from '../../types';

const PineconeServer: MCPServerInfo = {
  serverId: 'PINECONE',
  name: 'Pinecone MCP',
  slug: 'pinecone',
  description: 'Pinecone MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/pinecone-io/pinecone-mcp',
    commitSha: '966fc53',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default PineconeServer;
